import { jsx } from 'react/jsx-runtime';
import { memo } from 'react';
import { Anchor } from '@zooplus/ui-components';
import { useTranslation } from '../../hook/use-translations.js';
import styles from './fallback.module.scss.js';

// eslint-disable-next-line react/display-name
const Fallback = memo(() => {
    const { t } = useTranslation();
    return (jsx("div", { className: styles.fallbackWrapper, children: jsx(Anchor, { onClick: () => window.location.reload(), "data-testid": "fallbackErrorMessage", isBold: true, children: t('customer-data.error.fallback.link') }) }));
});

export { Fallback };
//# sourceMappingURL=fallback.js.map
